<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    표-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :is-not-dot-in-label="true"
      title="시설관리"
      tableHeaderTitle="점검항목"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from '@/components/TableInspect'

export default {
  components: {
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        inspectList_1: [
          {
            id: 1,
            label: "1. 위험작업 시 안전모, 안전화 등 개인보호구를 착용하였는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 사다리 작업 시 안전한 작업방법을 숙지하고 있는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 각종 계기류 확인 시 감전 예방을 위한 절연장갑을 착용하였는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 기계 점검, 보수 시 동력원을 완전히 차단 후 작업하는가?",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. 고장난 승강기를 임의로 열거나 기기를 조작하지는 않는가?",
            is_checked: "",
          },
          {
            id: 6,
            label: "6. 승강기 점검, 보수 시 접근금지 표지판을 부착하는가?",
            is_checked: "",
          },
          {
            id: 7,
            label: "7. 각종 전기기구 작업 시 작업자가 감전사고에 대한 작업방법을 확실하게 인지하고 있는가? ",
            is_checked: "",
          },
          {
            id: 8,
            label: "8. 화학물질 취급 및 저장 시 별도의 지정된 장소에 보관하는가? ",
            is_checked: "",
          },
          {
            id: 9,
            label: "9. 사용하는 화학물질의 위험성 또는 유해성에 대해 정확히 알고 있는가?",
            is_checked: "",
          },
          {
            id: 10,
            label: "10. 소화기 및 소화전의 작동 및 사용방법을 아는가?",
            is_checked: "",
          },
          {
            id: 11,
            label: "11. 무거운 물체 운반 시 2인 1조로 작업을 실시하는가?",
            is_checked: "",
          },
          {
            id: 12,
            label: "12. 올바른 중량물 취급방법에 대해 알고 있는가?",
            is_checked: "",
          },
          {
            id: 13,
            label: "13. 작업 전, 중, 후 주기적으로 스트레칭을 하였는가?",
            is_checked: "",
          },

        ],
      },
    };
  },
  methods: {
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
  },
};
</script>

<style scoped lang="scss">
</style>
